"use client";

import { useEffect, useState } from "react";

const useMediaQuery = (query: string) => {
  const getInitial = () => (typeof window !== "undefined" ? window.matchMedia(query).matches : false);
  const [matches, setMatches] = useState<boolean>(getInitial);
  useEffect(() => {
    if (typeof window === "undefined") return;
    const mediaQueryList = window.matchMedia(query);
    const handleResize = () => {
      setMatches(mediaQueryList.matches);
    };
    if (typeof mediaQueryList.addEventListener === "function") {
      mediaQueryList.addEventListener("change", handleResize);
    } else if (typeof (mediaQueryList as any).addListener === "function") {
      (mediaQueryList as any).addListener(handleResize);
    }
    return () => {
      if (typeof mediaQueryList.removeEventListener === "function") {
        mediaQueryList.removeEventListener("change", handleResize);
      } else if (typeof (mediaQueryList as any).removeListener === "function") {
        (mediaQueryList as any).removeListener(handleResize);
      }
    };
  }, [query]);
  return matches;
};

export default useMediaQuery;
